import { motion } from 'framer-motion';
import React, { FC } from 'react';
import { FaTimes } from 'react-icons/fa';
import fadeIn from '../../animations/fadeIn';
import './_styles.modal.css';

interface ModalProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: FC<ModalProps> = ({ visible, children, onClose }) => {
  if (!visible) {
    return (
      <motion.div
        layout
        layoutId='modal-blur'
        className='modal-backdrop hidden'
      ></motion.div>
    );
  }

  return (
    <motion.div layout layoutId='modal-blur' className='modal-backdrop'>
      <motion.div
        className='modal-body'
        variants={fadeIn(-1)}
        initial='hidden'
        animate='enter'
        exit='exit'
      >
        <button className='modal-close-button' onClick={onClose}>
          <FaTimes />
        </button>
        {children}
      </motion.div>
    </motion.div>
  );
};
export default Modal;
